import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=0aaec28a&"
import script from "./OrderComplete.vue?vue&type=script&lang=ts&"
export * from "./OrderComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports